import React from 'react'
import '../CSS/aboutus.css';
import { Link } from 'react-router-dom';
import aboutBusiness from "../images/home/business.jpg";
import client from "../images/home/Clientfocused.png";
import quality from "../images/home/quality.png";
import partnership from "../images/home/partnership.png";
import timely from "../images/home/timely.png";
function About() {
  return (

    <div className="about-page">
      
      {/* ================= HERO ================= */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">

            <h1> Technology That Helps
              <span> Businesses Grow</span>
            </h1>
            <p>
              We are a technology startup focused on developing innovative, scalable,
              and user-friendly software solutions that solve real business problems.
            </p>
            <div className="about-hero-buttons">
              <Link to="/contactus" className="about-primary-button" >
                Let's Work Together
              </Link>
              <Link to="/services" className="about-secondary-button" >
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* ================= WHO WE ARE ================= */}
      <section className="about-business-section">
        <div className="container">
          <div className="row g-5 align-items-center">
            {/* IMAGE */}
            <div className="col-lg-6">
              <div className="about-image-card">
                <img src={aboutBusiness} alt="YperSystem technology solutions" />
                <div className="about-image-overlay">
                  <span>TECHNOLOGY & INNOVATION</span>
                  <h3> Building Solutions Around Your Business </h3>
                </div>
              </div>
            </div>
            {/* CONTENT */}
            <div className="col-lg-6">
              <div className="about-content">

                <h2> Technology With A
                  <span> Business-First Approach</span>
                </h2>
                <p>
                  YperSystem Solution is a technology company focused on
                  developing software solutions that help businesses improve efficiency,
                  automate processes, and achieve sustainable growth.
                </p>
                <p>
                  We work closely with startups, small businesses,
                  and growing enterprises to understand their requirements
                  and create solutions that are practical, scalable, secure,
                  and easy to use.
                </p>
                <div className="about-divider"></div>
                <h3> Solutions Built Around Your Needs </h3>
                <p>
                  From custom software and ERP systems to web, mobile, cloud, database,
                  and AI solutions, our approach is centered around
                  solving real business challenges with technology.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MISSION ================= */}
      <section className="about-mission-section">
        <div className="container">
          <div className="about-heading text-center">
            <span className="about-section-label"> OUR MISSION </span>
            <h2> Making Technology<br/>
              <span> Work For Your Business</span>
            </h2>
            <p>
              Our mission is to help businesses use technology
              effectively to improve operations, productivity, and
              customer experiences.
            </p>
          </div>
          <div className="row g-4 mt-3">
            <div className="col-lg-4 col-md-6">
              <div className="about-mission-card">

                <h3> Solve Real Problems </h3>
                <p>
                  We focus on understanding business challenges before
                  developing technology solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-mission-card">

                <h3> Build Scalable Solutions </h3>
                <p>
                  We create software that can adapt and grow
                  as your business requirements evolve.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mx-auto">
              <div className="about-mission-card">

                <h3> Enable Business Growth </h3>
                <p>
                  We use technology to improve efficiency,
                  productivity, automation, and customer experiences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= WHAT WE DO ================= */}
      <section className="about-solutions-section">
        <div className="container">
          <div className="about-heading text-center">
            <span className="about-section-label"> WHAT WE DO </span>
            <h2> Technology Solutions For<br/>
              <span> Modern Businesses</span>
            </h2>
            <p>
              We provide a range of technology services designed around
              different business requirements.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> Custom Software</h3>
                <p>
                  Tailored software solutions designed around specific
                  business processes, requirements, and operational needs.
                </p>
                <Link to="/services/custom-software">Learn More →</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> Business & ERP </h3>
                <p>
                  Business management systems for inventory, sales,
                  purchases, accounting, customers, and daily operations.
                </p>
                <Link to="/services/erp-business">Learn More → </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> Web & Mobile </h3>
                <p>
                  Modern, responsive web and mobile applications built around business
                  goals and customer needs.</p>
                <Link to="/services/web-application">Learn More → </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> Cloud Solutions </h3>
                <p>
                  Scalable cloud-based applications that provide accessibility,
                  flexibility, and reliable performance.</p>
                <Link to="/services/cloud-solutions">Learn More →</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> AI Solutions</h3>
                <p>
                  AI-powered solutions for automation, intelligent assistants,
                  content creation, and smarter business processes.
                </p>
                <Link to="/ai/business-solutions">Explore AI →</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="about-solution-card">
                <h3> Digital Solutions
                </h3>
                <p>
                  Website development, digital marketing, SEO, hosting, frontend
                  development, and database solutions.
                </p>
                <Link to="/services/website-development">Learn More → </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= WHY CHOOSE US ================= */}
      <section className="about-why-section">
        <div className="container">
          <div className="about-heading text-center">
            <span className="about-section-label">
              WHY CHOOSE US </span>
            <h2> Our Approach Makes<br/>
              <span> The Difference</span>
            </h2>
            <p>
              We believe successful technology projects start with understanding
              the business behind them.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-lg-3 col-md-6">
              <div className="about-why-card">
                <div className="about-why-image">
                  <img src={client} alt="Client focused" />
                </div>
                <div className="about-why-content">
                  <h3> Client-Focused </h3>
                  <p>
                    We understand your business goals and requirements
                    before developing your solution.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="about-why-card">
                <div className="about-why-image">
                  <img src={quality} alt="Quality development" />
                </div>
                <div className="about-why-content">
                  <h3> Quality Development </h3>
                  <p>
                    We build clean, maintainable, secure,
                    and scalable software using modern development practices.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="about-why-card">
                <div className="about-why-image">
                  <img src={timely} alt="Timely delivery" />
                </div>
                <div className="about-why-content">
                  <h3> Timely Delivery </h3>
                  <p>
                    Effective planning and development help us deliver
                    projects efficiently and on schedule.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="about-why-card">
                <div className="about-why-image">
                  <img src={partnership} alt="Long term partnership" />
                </div>
                <div className="about-why-content">
                  <h3> Long-Term Partnership </h3>
                  <p>
                    We continue to support, maintain, and
                    improve your software as your business grows.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= TECHNOLOGY ================= */}
      <section className="about-technology-section">
        <div className="container">
          <div className="about-technology-box">
            <div className="about-technology-content">
              <span className="about-section-label">
                TECHNOLOGY & INNOVATION </span>
              <h2> Ready To Build
                <span> Something Better?</span>
              </h2>
              <p> Whether you need a custom application, business management
                system, digital solution, or AI-powered technology,
                we can help turn your idea into a practical solution.
              </p>
            </div>
            <Link to="/contactus" className="about-cta-button" >
              Get In Touch
            </Link>

          </div>
        </div>
      </section>
    </div>
  )
}

export default About
